import React from 'react'
import Skeleton from 'react-loading-skeleton'

import useStyles from './styles'

const RequiredCreativeSizesSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.requiredCreativeSizesContainer}>
      <h5 className={classes.title}>
        <Skeleton width={180} height={20} />
      </h5>
      <div className={classes.videoAndImageRow}>
        <div className={classes.column}>
          <h6 className={classes.title}>
            <Skeleton width={60} height={16} />
          </h6>
          <Skeleton width={120} height={14} style={{ marginBottom: 4 }} />
          <Skeleton width={100} height={14} style={{ marginBottom: 4 }} />
          <Skeleton width={110} height={14} />
        </div>
        <div className={classes.column}>
          <h6 className={classes.title}>
            <Skeleton width={50} height={16} />
          </h6>
          <Skeleton width={90} height={14} style={{ marginBottom: 4 }} />
          <Skeleton width={80} height={14} style={{ marginBottom: 4 }} />
          <Skeleton width={95} height={14} />
        </div>
      </div>
    </div>
  )
}

export default RequiredCreativeSizesSkeleton
